export default {
  SET_METHODS(state, methods) {
    state.methods = methods;
  },
  ADD_METHOD(state, method) {
    state.methods.push(method);
  },
  UPDATE_METHOD(state, updatedMethod) {
    const index = state.methods.findIndex(method => method._id === updatedMethod._id);
    if (index !== -1) {
      state.methods.splice(index, 1, updatedMethod);
    }
  },
  DELETE_METHOD(state, methodId) {
    state.methods = state.methods.filter(method => method._id !== methodId);
  },
  SET_LOADING(state, loading) {
    state.loading = loading;
  },
  SET_ERROR(state, error) {
    state.error = error;
  },
};
